import axios from 'axios'

import {
    GET_INBOX_START,
    GET_INBOX_SUCCESS,
    GET_INBOX_FAIL,
    GET_CONVERSATION_START,
    GET_CONVERSATION_SUCCESS,
    REGISTER_SOCKET_MESSAGE,
    RECLASSIFY_START,
    RESET_HISTORICAL_DIALOGUE,
    GET_STATUSES_START,
    GET_STATUSES_SUCCESS,
    GET_STATUSES_FAIL,
    GET_INTENT_ENTITY_MAP_START,
    GET_INTENT_ENTITY_MAP_SUCCESS,
    GET_DIALOGUE_GENERAL_INFO_START,
    GET_DIALOGUE_GENERAL_INFO_SUCCESS,
    // GET_DIALOGUE_GENERAL_INFO_FAIL,
    GET_TAB_COUNT_SUCCESS,
    GET_ADF_START,
    GET_ADF_SUCCESS,
    GET_SETTINGS_SUCCESS,
    GET_STOPBOTEVENTS_START,
    GET_STOPBOTEVENTS_SUCCESS,
} from './constants'

export const getInbox = data => dispatch => {
    dispatch({
        type: GET_INBOX_START,
        payload: {
            accumulate: data.accumulate,
            type: data.type,
            refresh: data.refresh,
        },
    })

    const {
        searchString, conversationId, accountIdParam, fromTestPage
    } = data
    let url = '/api/threads'

    if (searchString || conversationId || accountIdParam) {
        url += '/search'
    }

    const authorization = localStorage.getItem(
        'pulsarBotPlatform_operatorToken'
    )

    axios({
        url,
        method: 'post',
        headers: { authorization },
        data,
    })
        .then(res => {
            dispatch({
                type: GET_INBOX_SUCCESS,
                payload: {
                    inboxNewData: res.data,
                    accumulate: data.accumulate,
                    fromTestPage,
                },
            })
        })
        .catch(() => {
            dispatch({
                type: GET_INBOX_FAIL,
            })
        })
}

export const getHistoricalDialogue = data => dispatch => {
    console.log('whoami => [getHistoricalDialogue]')
    dispatch({
        type: GET_CONVERSATION_START,
    })

    const authorization = localStorage.getItem(
        'pulsarBotPlatform_operatorToken'
    )

    axios({
        method: 'post',
        url: '/api/operators/inbox/dialogue',
        headers: { authorization },
        data,
    })
        .then(res => {
            // eslint-disable-next-line no-console
            dispatch({
                type: GET_CONVERSATION_SUCCESS,
                payload: res.data,
            })
        })
        .catch(e => {
            console.log('Caught error:', e)
            // dispatch({})
        })
}

export const getStatuses = data => dispatch => {
    dispatch({
        type: GET_STATUSES_START,
    })

    const authorization = localStorage.getItem(
        'pulsarBotPlatform_operatorToken'
    )

    axios({
        method: 'post',
        url: '/api/operators/inbox/statuses',
        headers: { authorization },
        data,
    })
        .then(res => {
            const dataItems = JSON.parse(res.data.Items)

            // eslint-disable-next-line no-console
            dispatch({
                type: GET_STATUSES_SUCCESS,
                payload: dataItems,
            })
        })
        .catch(() => {
            dispatch({
                type: GET_STATUSES_FAIL,
            })
        })
}

export const registerSocketMessage = data => dispatch => {
    dispatch({
        type: REGISTER_SOCKET_MESSAGE,
        payload: data,
    })
}

export const resetHistoricalDialogue = () => dispatch => {
    dispatch({
        type: RESET_HISTORICAL_DIALOGUE,
    })
}

export const reclassifyMessage = (messageToEdit, newIntents, humanMessage) => dispatch => {
    dispatch({
        type: RECLASSIFY_START,
        payload: { botMessage: messageToEdit },
    })

    const authorization = localStorage.getItem(
        'pulsarBotPlatform_operatorToken'
    )
    console.log('SENDING [reclassifyMessage] ->', newIntents)

    const username = localStorage.getItem(
        'pulsarBotPlatform_operatorUsername'
    )
    // eslint-disable-next-line no-param-reassign
    messageToEdit.HandlerMeta = {
        EditedBy: username,
    }

    axios({
        method: 'post',
        url: '/api/conversations/reclassify',
        headers: { authorization },
        data: { messageToEdit, newIntents, humanMessage },
    })
}

export const getIntentEntityMap = () => dispatch => {
    const authorization = localStorage.getItem(
        'pulsarBotPlatform_operatorToken'
    )
    const data = {
        config_id: 'general__intent-entity-map',
        version: '0.0.1',
    }

    dispatch({
        type: GET_INTENT_ENTITY_MAP_START,
    })
    axios({
        method: 'POST',
        url: '/api/operators/general/intent-entity-map',
        headers: { authorization },
        data,
    })
        .then(res => {
            dispatch({
                type: GET_INTENT_ENTITY_MAP_SUCCESS,
                payload: res.data,
            })
        })
        .catch(e => {
            console.log('Caught error:', e)
            // dispatch({})
        })
}

export const getDialogueGeneralInfo = data => dispatch => {
    dispatch({
        type: GET_DIALOGUE_GENERAL_INFO_START,
    })

    const authorization = localStorage.getItem(
        'pulsarBotPlatform_operatorToken'
    )
    const { account, conversationId } = data

    axios({
        method: 'GET',
        url: `/api/operators/general/dialogue?AccountId=${account}&ConversationId=${conversationId}`,
        headers: { authorization },
    })
        .then(res => {
            dispatch({
                type: GET_DIALOGUE_GENERAL_INFO_SUCCESS,
                payload: res.data,
            })
        })
        .catch(e => {
            console.log('Caught error:', e)
            // dispatch({})
        })
}

export const getAdf = data => dispatch => {
    dispatch({
        type: GET_ADF_START,
    })

    const authorization = localStorage.getItem(
        'pulsarBotPlatform_operatorToken'
    )
    const { account, conversationId } = data

    axios({
        method: 'GET',
        url: `/api/operators/general/adf?AccountId=${account}&ConversationId=${conversationId}`,
        headers: { authorization },
    })
        .then(res => {
            dispatch({
                type: GET_ADF_SUCCESS,
                payload: res.data,
            })
        })
        .catch(() => {
            // dispatch({})
        })
}

export const getTabCount = params => dispatch => {
    const authorization = localStorage.getItem(
        'pulsarBotPlatform_operatorToken'
    )

    axios({
        method: 'GET',
        url: '/api/threads/count',
        headers: { authorization },
        params,
    })
        .then(res => {
            dispatch({
                type: GET_TAB_COUNT_SUCCESS,
                payload: res.data,
            })
        })
        .catch(() => {})
}

export const getSettings = accountId => dispatch => {
    const authorization = localStorage.getItem(
        'pulsarBotPlatform_operatorToken'
    )

    axios({
        method: 'GET',
        url: '/api/operators/general/settings',
        headers: { authorization },
        params: { accountId },
    })
        .then(res => {
            dispatch({
                type: GET_SETTINGS_SUCCESS,
                payload: res.data,
            })
        })
        .catch(() => {})
}

export const getStopBotEvents = data => dispatch => {
    console.log('whoami => [getStopBotEvents]')
    dispatch({ type: GET_STOPBOTEVENTS_START })
    const authorization = localStorage.getItem(
        'pulsarBotPlatform_operatorToken'
    )
    axios({
        method: 'get',
        url: '/api/operators/inbox/stop-bot-events',
        headers: { authorization },
        params: data,
    })
        .then(res => {
            // eslint-disable-next-line no-console
            dispatch({
                type: GET_STOPBOTEVENTS_SUCCESS,
                payload: res.data,
            })
        })
        .catch(e => {
            console.log('Caught error:', e)
            dispatch([])
        })
}
